// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2MCNK","ranges":"BmiRanges_ranges__1esF1"};